import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { EMPLOYERS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateEmployerBillingScheduleAction = createAsyncThunk(
    'benefit/updateEmployerBillingScheduleAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.put(`${ EMPLOYERS_PATH }/${ data.employerId }/billing-details?type=${ data.type }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateEmployerBillingScheduleSlice = createSlice({
    name: 'updateEmployerBillingScheduleSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateEmployerBillingScheduleAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateEmployerBillingScheduleAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateEmployerBillingScheduleAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateEmployerBillingScheduleState = (state) => state.benefit.updateEmployerBillingSchedule;
export default updateEmployerBillingScheduleSlice.reducer;
